var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweetheartLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 110,
    viewBox: "0 0 12 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30201 0L11.802 1.5C3.42494 44.1615 2.19522 65.2701 11.802 108.5L7.30201 110C-3.03128 68.1843 -1.77342 43.9955 7.30201 0Z",
    fill: "#71AD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetheartLeft);
export default __webpack_public_path__ + "static/media/sweetheart-left.5ab8eed197dfd996cbafc01acbe3f245.svg";
export { ForwardRef as ReactComponent };